import React, { Component } from "react";
import { connect } from "react-redux";
import RaisedButton from "material-ui/RaisedButton";
import TextField from "material-ui/TextField";
import { Card, CardTitle, CardText, CardHeader } from "material-ui/Card";

import { updateMealplan } from "./actions";
import Flags from "./Flags";

import "../common.css";
import "./Accomodation.css";

const mealplanLabels = {
  BB: "petit déjeuner inclus",
  BD: "petit déjeuner et dîner",
  HB: "demi-pension",
  FB: "pension complète",
  AI: "tout inclus",
  RO: "chambre seule"
};

const displayMealplanLabel = mealplanCode => {
  return mealplanLabels[mealplanCode];
};

class AccomodationMealplans extends Component {
  state = { mealplans: [] };

  componentDidMount() {
    const { mealplans } = this.props;
    if (mealplans !== undefined && mealplans.length > 0) {
      this.setState({ mealplans });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { mealplans } = this.props;
    const updateState =
      prevProps.mealplans.length !== mealplans.length ||
      (prevProps.mealplans.length > 0 &&
        this.props.mealplans.length > 0 &&
        prevProps.mealplans[0].lang !== this.props.mealplans[0].lang);
    if (updateState) {
      this.setState({ mealplans });
    }
  }

  handleSubmit = mealplanCode => e => {
    e.preventDefault();
    const { merchantCode, lang } = this.props;
    const mealplan = this.state.mealplans.filter(
      mealplan => mealplan.mealplan === mealplanCode
    );
    if (mealplan.length === 1) {
      const { description } = mealplan[0];
      this.props.updateMealplan(merchantCode, mealplanCode, description, lang);
    }
  };

  changeDescription = mealplanCode => (e, value) => {
    const { mealplans } = this.state;
    const possibleMealplans = mealplans
      .map((mealplan, index) => {
        return Object.assign({}, mealplan, { index });
      })
      .filter(mealplan => {
        return mealplan.mealplan === mealplanCode;
      });
    const mealplanIndex =
      possibleMealplans.length === 1 ? possibleMealplans[0].index : -1;
    if (mealplanIndex !== -1) {
      const mealplan = mealplans[mealplanIndex];
      mealplan.description = value;
      this.setState({
        mealplans: [
          ...mealplans.slice(0, mealplanIndex),
          mealplan,
          ...mealplans.slice(mealplanIndex + 1)
        ]
      });
    }
  };

  renderMealplan = mealplan => {
    return (
      <Card expandable={true} className="secondaryCard">
        <CardHeader
          className={"secondaryCard--header"}
          title={`Plan-repas ${displayMealplanLabel(mealplan.mealplan)}`}
          subtitle={""}
          actAsExpander={true}
          showExpandableButton={true}
        />
        <CardText className="cardText meal-plan-inner" expandable={true}>
          <form onSubmit={this.handleSubmit(mealplan.mealplan)}>
            <div className="fieldset">
              <TextField
                floatingLabelText="Description du plan-repas"
                value={mealplan.description}
                onChange={this.changeDescription(mealplan.mealplan)}
                multiLine={true}
                fullWidth
              />
            </div>
            <RaisedButton
              type="submit"
              secondary
              className="form-validate-btn"
              label="Valider"
            />
          </form>
        </CardText>
      </Card>
    );
  };

  renderMealplans = () => {
    const { mealplans } = this.state;
    return mealplans && mealplans.length > 0 ? (
      <div>
        <Card className="secondaryCard">
          <CardTitle
            className={"secondaryCard--title"}
            title={<Flags prevText="Les plans-repas " />}
            subtitle={"Modifiez les descriptions des plans-repas disponibles"}
          />
        </Card>
        {mealplans.map(mealplan => {
          return <div key={mealplan.id}>{this.renderMealplan(mealplan)}</div>;
        })}
      </div>
    ) : (
      undefined
    );
  };

  render() {
    return <div>{this.renderMealplans()}</div>;
  }
}

const mapStateToProps = state => ({
  merchantCode: state.merchant.detail.code,
  mealplans: state.accomodation.mealplans,
  lang: state.accomodation.lang
});

const mapDispatchToProps = dispatch => ({
  updateMealplan: (merchantCode, mealplan, description, lang) => {
    dispatch(updateMealplan(merchantCode, mealplan, description, lang));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccomodationMealplans);



// WEBPACK FOOTER //
// ./src/merchant/accomodation/AccomodationMealplans.js